module.exports = {"fr-FR":{"notifications":{"index":{"title":"Notifications","empty":"Sans résultats","unread":"Seulement les notifications non lues"}}}}